import React from 'react';

export const MoneyIcon = props => (
  <svg viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g stroke="#545D69" fill="none">
      <path d="M13.917 3.083c0 .921-2.798 1.667-6.25 1.667s-6.25-.746-6.25-1.667c0-.92 2.798-1.666 6.25-1.666s6.25.746 6.25 1.666h0z" />
      <path d="M13.917 3.083v2.5c0 .921-2.798 1.667-6.25 1.667s-6.25-.746-6.25-1.667v-2.5" />
      <path d="M13.917 5.583v2.5c0 .921-2.798 1.667-6.25 1.667s-6.25-.746-6.25-1.667v-2.5M20.583 13.917c0 .92-2.797 1.666-6.25 1.666-3.451 0-6.25-.745-6.25-1.666 0-.92 2.799-1.667 6.25-1.667 3.453 0 6.25.747 6.25 1.667h0z" />
      <path d="M20.583 13.917v2.5c0 .92-2.797 1.666-6.25 1.666-3.451 0-6.25-.745-6.25-1.666v-2.5" />
      <path d="M20.583 16.417v2.5c0 .92-2.797 1.666-6.25 1.666-3.451 0-6.25-.745-6.25-1.666v-2.5M13.917 8.083v2.5c0 .921-2.798 1.667-6.25 1.667s-6.25-.746-6.25-1.667v-2.5" />
      <path d="M1.417 10.583v2.5c0 .921 2.798 1.667 6.25 1.667h.416" />
      <path d="M1.417 13.083v2.5c0 .921 2.798 1.667 6.25 1.667h.416M13.917 10.583v1.667" />
    </g>
  </svg>
);
